(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
class FaqAccordion extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.reluv-faq__question').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.reluv-faq__item');
        const isOpen = item.hasAttribute('data-open');
        item.toggleAttribute('data-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }
}
customElements.define('faq-accordion', FaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reluv-contact-faq"] && !Shopify.designMode) return;
  try {
    
class ContactFileUpload extends HTMLElement {
  connectedCallback() {
    const input = this.querySelector('.reluv-contact__file-input');
    const list = this.querySelector('.reluv-contact__file-list');
    const form = this.closest('form');
    if (!input || !list) return;

    input.addEventListener('change', () => {
      const files = Array.from(input.files || []);
      if (files.length > 3) {
        input.value = '';
        list.innerHTML = '<li class="reluv-contact__file-error">Please select up to 3 photos only.</li>';
        return;
      }
      list.innerHTML = files.map(f => `<li class="reluv-contact__file-item">${f.name}</li>`).join('');
    });

    if (form) {
      form.addEventListener('submit', () => {
        const files = Array.from(input.files || []);
        if (!files.length) return;
        const textarea = form.querySelector('textarea[name="contact[body]"]');
        if (textarea) {
          const names = files.map(f => f.name).join(', ');
          textarea.value += `\n\n---\nPhotos referenced: ${names}`;
        }
      });
    }
  }
}
customElements.define('contact-file-upload', ContactFileUpload);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reluv-new-arrivals"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.reluv-na__atc-btn[data-variant-id]').forEach(function(btn) {
    btn.addEventListener('click', async function() {
      var id = parseInt(btn.dataset.variantId, 10);
      var orig = btn.textContent.trim();
      btn.textContent = '...';
      btn.disabled = true;
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
        if (!res.ok) throw new Error();
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (_) {
        btn.textContent = orig;
        btn.disabled = false;
      }
      setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 2200);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reluv-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.getElementById('reluv-sticky-atc');
  if (!bar) return;

  var sentinel = document.querySelector('.product__info-container .product-form__submit, .product-form__submit, [name="add"]');
  if (!sentinel) {
    sentinel = document.querySelector('.product__info-container, .product__description');
  }

  if (sentinel && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bar.removeAttribute('data-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.setAttribute('data-visible', '');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
    observer.observe(sentinel);
  } else {
    bar.setAttribute('data-visible', '');
    bar.setAttribute('aria-hidden', 'false');
  }

  var atcBtn = bar.querySelector('.reluv-sticky-atc__btn[data-variant-id]');
  if (atcBtn) {
    atcBtn.addEventListener('click', async function() {
      var id = parseInt(atcBtn.dataset.variantId, 10);
      var orig = atcBtn.textContent.trim();
      atcBtn.textContent = '...';
      atcBtn.disabled = true;
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
        if (!res.ok) throw new Error();
        atcBtn.textContent = 'Added!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (_) {
        atcBtn.textContent = orig;
        atcBtn.disabled = false;
      }
      setTimeout(function() { atcBtn.textContent = 'Add to Cart'; atcBtn.disabled = false; }, 2000);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
